import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { CUSTOMER_TYPE_FIELD } from "../../../../types/customer.js";
import { __ } from "../../../../utils/i18n.js";
/**
 * Segmented radio group bound to the `customerType` form field. The selected
 * value gates the visibility of company name, VAT ID and invoice-address fields
 * in the surrounding form.
 */ const CustomerTypeSwitch = ()=>/*#__PURE__*/ _jsx(Form.Item, {
        name: CUSTOMER_TYPE_FIELD,
        label: __("Purchase for"),
        children: /*#__PURE__*/ _jsx(Radio.Group, {
            options: [
                {
                    label: __("Individual"),
                    value: "individual"
                },
                {
                    label: __("Company/Organization"),
                    value: "company"
                }
            ],
            optionType: "button"
        })
    });
export { CustomerTypeSwitch, CUSTOMER_TYPE_FIELD };
